import { MenuListContainer } from '@/presentation/menu-item-group/MenuItemGroup.styled';
import styled from 'styled-components';

interface IIconProps {
  active?: boolean;
  color?: 'light' | 'dark';
}

export const SIcon = styled.div<IIconProps>`
  width: 55px !important;
  height: 55px;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  font-size: 22px;
  border-radius: 5px;
  cursor: pointer;

  ${({ active, theme }) => active && `background-color: ${theme.colors.tertiaryBackground};`}

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBackground};
  }

  ${({ color, theme }) => {
    if (color === 'light') {
      return `
        color: ${theme.colors.lightIcon};
      `;
    } else {
      return `
        color: ${theme.colors.tertiaryText};
      `;
    }
  }}
`;

export const SWrapper = styled.div`
  height: 100vh;
  width: 65px;

  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 100;

  background-color: ${({ theme }) => theme.colors.secondaryBackground};

  div {
    width: 100%;
    text-align: center;
  }

  ${MenuListContainer} {
    width: 0;
  }
`;

export const SMarginTop = styled.div`
  height: 3%;
`;

export const SSectionOne = styled.div`
  height: 10%;
  min-height: 25px;
`;

export const SLogo = styled.img`
  width: 70%;
  cursor: pointer;
  object-fit: contain;

  &.no-pointer {
    cursor: auto;
  }
`;

export const SSectionTwo = styled.div`
  height: 13%;
  min-height: 50px;
`;

interface ICreateMessageProps {
  isActive: boolean;
}

export const SCreateMessage = styled.div<ICreateMessageProps>`
  height: 50px;
  width: 50px !important;

  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;

  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.secondaryBorder};
  cursor: pointer;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.icon};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryBackground};
  }

  ${({ isActive, theme }) => {
    if (isActive) {
      return `
        border: none;
        background-color: ${theme.colors.tertiaryBackground}
      `;
    }
  }}
`;

export const SSectionThree = styled.div`
  height: 46%;
  min-height: 325px;

  @media (max-height: 670px) {
    height: 0;
  }
`;

export const SSectionFour = styled.div`
  position: absolute;
  left: 0;
  bottom: 5px;

  @media (max-height: 670px) {
    position: static;
  }
`;
